import { COMPONENTS, DeepPartial, RecommendationsConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_RECOMMENDATIONS_CONFIG: DeepPartial<RecommendationsConfig> = {
  components: {
    grid: COMPONENTS.PANELS.SlidingPanel
  }
};

export const DESKTOP_RECOMMENDATIONS_CONFIG: DeepPartial<RecommendationsConfig> = {
  infiniteScrollDefaultEnabled: false,
  pageSize: 24
};
